import { DesignProp, GeneralProp } from "../PropCategories";

export const color = {
  prop: "style-attribute",
  name: "Color",
  nameI18n: "builder_ui.prop_type.styles.color",
  category: [DesignProp, GeneralProp],
  type: "color",
  defaultValue: "#000000",
} as const;
